import Badge from "../Badge";

type BadgesProps = {
  statusColor: string;
  statusText: string;
  flagCount: number;
};

export function Badges({ flagCount, statusColor, statusText }: BadgesProps) {
  const label = flagCount > 1 ? "Flags" : "Flag";

  return (
    <>
      <Badge text={statusText} color={statusColor} />
      {flagCount > 0 ? (
        <Badge
          text={`${flagCount} ${label}`}
          style={{ marginLeft: 8 }}
          color="red"
        />
      ) : null}
    </>
  );
}
